import ExternalAPIClient from '../api_external_helper';
import { api, user_providers } from '../../config';
import * as url from '../data_providers/url_helper';
import qs from 'qs';

const apiClient = new ExternalAPIClient(
	api.REACT_APP_SPED_DATA_PROVIDERS_API_URL
);


let authToken = null; // Variable para almacenar el token de autenticación

export const authenticate = async (username, password) => {
	try {
		// Autenticar solo si el token no ha sido obtenido previamente
		if (!authToken) {
			const response = await apiClient.authenticate(username, password);
			authToken = response;
		}
	} catch (error) {
		console.error('Error durante la autenticación:', error.message);
		throw error;
	}
};

export const stringifyParams = params =>
	qs.stringify(params, { encodeValuesOnly: true });

export const getDataReportOxygen = async data => {
	try {
		await authenticate(data.username, data.password);

		const queryParams = {
			start: data.start,
			end: data.end,
			interval: data.interval,
			siep: data.siep,
			variable: data.variable,
		};

		const queryString = stringifyParams(queryParams);
		const urlWithParams = `${url.DATA_PROVIDERS_REPORT}/${data.service}?${queryString}`;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos de oxígeno:', error.message);
		throw error;
	}
};

export const getDataReportTemperature = async data => {
	try {
		await authenticate(data.username, data.password);

		const queryParams = {
			start: data.start,
			end: data.end,
			interval: data.interval,
			siep: data.siep,
			variable: data.variable,
		};

		const queryString = stringifyParams(queryParams);
		const urlWithParams = `${url.DATA_PROVIDERS_REPORT}/${data.service}?${queryString}`;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error(
			'Error al obtener los datos de temperatura:',
			error.message
		);
		throw error;
	}
};

export const getDataReportSaturation = async data => {
	try {
		await authenticate(data.username, data.password);

		const queryParams = {
			start: data.start,
			end: data.end,
			interval: data.interval,
			siep: data.siep,
			variable: data.variable,
		};

		const queryString = stringifyParams(queryParams);
		const urlWithParams = `${url.DATA_PROVIDERS_REPORT}/${data.service}?${queryString}`;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos de saturación:', error.message);
		throw error;
	}
};

export const getDataReportSalinity = async data => {
	try {
		await authenticate(data.username, data.password);

		const queryParams = {
			start: data.start,
			end: data.end,
			interval: data.interval,
			siep: data.siep,
			variable: data.variable,
		};

		const queryString = stringifyParams(queryParams);
		const urlWithParams = `${url.DATA_PROVIDERS_REPORT}/${data.service}?${queryString}`;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos de salinidad:', error.message);
		throw error;
	}
};

export const getDataReportChlorophyll = async data => {
	try {
		await authenticate(data.username, data.password);

		const queryParams = {
			start: data.start,
			end: data.end,
			interval: data.interval,
			siep: data.siep,
			variable: data.variable,
		};

		const queryString = stringifyParams(queryParams);
		const urlWithParams = `${url.DATA_PROVIDERS_REPORT}/${data.service}?${queryString}`;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos de clorofila:', error.message);
		throw error;
	}
};

export const getDataReportTurbidity = async data => {
	try {
		await authenticate(data.username, data.password);

		const queryParams = {
			start: data.start,
			end: data.end,
			interval: data.interval,
			siep: data.siep,
			variable: data.variable,
		};

		const queryString = stringifyParams(queryParams);
		const urlWithParams = `${url.DATA_PROVIDERS_REPORT}/${data.service}?${queryString}`;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos de tubidez:', error.message);
		throw error;
	}
};

export const getDataReportAll = async data => {
	try {
		await authenticate(data.username, data.password);

		const queryParams = {
			start: data.start,
			end: data.end,
			interval: data.interval,
			siep: data.siep,
			variable: data.variable,
		};

		const queryString = stringifyParams(queryParams);
		const urlWithParams = `${url.DATA_PROVIDERS_REPORT}/${data.service}?${queryString}`;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};

export const getMeasurementsList = async params => {
	try {
		const authData = {
			username: user_providers.USER,
			password: user_providers.PASS,
		};

		await authenticate(authData.username, authData.password);

		const queryString = stringifyParams(params);
		const urlWithParams =
			url.DATA_PROVIDERS_GET_MEASUREMENTS + '?' + queryString;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};

export const getMeasurementsQuery = async query => {
	try {
		const authData = {
			username: user_providers.USER,
			password: user_providers.PASS,
		};

		await authenticate(authData.username, authData.password);

		return await apiClient.get(
			url.DATA_PROVIDERS_GET_MEASUREMENTS_QUERY +
				'?' +
				stringifyParams(query),
			{
				headers: { Authorization: `Bearer ${authToken}` },
			}
		);
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};

export const getIncidentsQuery = async query => {
	try {
		const authData = {
			username: user_providers.USER,
			password: user_providers.PASS,
		};

		await authenticate(authData.username, authData.password);

		return await apiClient.get(
			url.DATA_PROVIDERS_GET_INCIDENTS_QUERY + '?' + stringifyParams(query),
			{
				headers: { Authorization: `Bearer ${authToken}` },
			}
		);
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};

export const getMeasurementsDetailQuery = async query => {
	try {
		const authData = {
			username: user_providers.USER,
			password: user_providers.PASS,
		};

		await authenticate(authData.username, authData.password);

		return await apiClient.get(
			url.DATA_PROVIDERS_GET_MEASUREMENTS_DETAIL_QUERY +
				'?' +
				stringifyParams(query),
			{
				headers: { Authorization: `Bearer ${authToken}` },
			}
		);
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};

export const getInformationRegisterSMAList = async params => {
	try {
		const authData = {
			username: user_providers.USER,
			password: user_providers.PASS,
		};

		await authenticate(authData.username, authData.password);

		const queryString = stringifyParams(params);
		const urlWithParams = url.DATA_PROVIDERS_GET_CATASTRO + '?' + queryString;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};


export const addInformationRegisterSMA = async params => {
	try {
		const authData = {
			username: user_providers.USER,
			password: user_providers.PASS,
		};

		await authenticate(authData.username, authData.password);

		const queryString = stringifyParams(params);
		const urlWithParams = url.DATA_PROVIDERS_ADD_CATASTRO + '?' + queryString;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};

export const getSitesList = async params => {
	try {
		const authData = {
			username: user_providers.USER,
			password: user_providers.PASS,
		};

		await authenticate(authData.username, authData.password);

		const queryString = stringifyParams(params);
		const urlWithParams = url.DATA_PROVIDERS_GET_SITES + '?' + queryString;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};

export const getProvidersList = async params => {
	try {
		const authData = {
			username: user_providers.USER,
			password: user_providers.PASS,
		};

		await authenticate(authData.username, authData.password);

		const queryString = stringifyParams(params);
		const urlWithParams =
			url.DATA_PROVIDERS_GET_PROVIDERS + '?' + queryString;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};

export const getProvidersOptionsList = async () => {
	try {
		const authData = {
			username: user_providers.USER,
			password: user_providers.PASS,
		};

		await authenticate(authData.username, authData.password);
		const urlWithParams = url.DATA_PROVIDERS_GET_PROVIDERS_OPTIONS;

		return await apiClient.get(urlWithParams, {
			headers: { Authorization: `Bearer ${authToken}` },
		});
	} catch (error) {
		console.error('Error al obtener los datos:', error.message);
		throw error;
	}
};

export const clearAuthToken = () => {
	authToken = null; // Función para limpiar el token, si es necesario
};
